Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ReviewQueueDashboardView extends Backbone.View
  template: JST["backbone/templates/monitoring/review_queue_dashboard"]
  className: 'dashboard'
  id: 'review-queue-monitoring-dashboard'

  initialize: (@options = {}) ->
    @topics = @options.topics
    @firstSearch = false
    @resultsElement = ''
    @scrollPosition = 0
    @filtersRendered = false
    @currentUser = Keepcon.currentUser.id
    @accountSettings = Keepcon.currentAccount.monitoringSettings
    @customerData = {settings: Keepcon.applicationSettings.customer, enabledForCurrentAccount: Keepcon.currentAccount.customerEnabled, users: Keepcon.customerUsers, usersGroups: Keepcon.customerUsersGroups}
    @eventAggregator.bind('showResultsView', @showResults)
    @filterView = destroy: ->
    @results = destroy: ->
    $(window).on('resize', @adjustHeight)
    @uuid = @options.reviewQueueId

  render: =>
    @$el.html(@template())
    @_activateOnBeforeUnloadEvent()
    @adjustHeight()
    $('.monitoring-dashboard').addClass('review-queues')
    return this

  restoreResults: ->
    @$el.find('#no_results').before(@resultsElement)

  newSearch: =>
    @$el.find('#dashboard-content').block()
    if Keepcon.currentAccount.dashboardSettings.review_mode_timeout_minutes
      @searchQuery = @createSearchQuery()
      @searchQuery.set('name', 'ReviewQueue')
      @firstSearch = true
      @doNewSearch()
    else
      swal({
          title: 'You must set a session timeout in account settings to use Review mode',
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn-danger',
          closeOnConfirm: true
        }
      )

  doNewSearch: ->
    @searchIsPending = false
    @results.destroy()
    @results  = new Monitoring.Views.ReviewQueueDashboardResultView({
      searchQuery: @searchQuery
      currentUser: @currentUser
      accountSettings: @accountSettings
      customerData: @customerData
    })
    @results.render()
    @$el.find('#results').append(@results.el)
    @$el.find('#results').hide()
    @results.bind('onReviewCountUpdated', (total) => @trigger('totalChanges', total))
    @results.bind('totalChanges', (response) => @trigger('totalChanges', response.total))
    @results.bind('searchCompleted', (response) => @afterSearch(response))
    @results.bind('onDone', (response) => @$el.find('#dashboard-content').block())
    @results.newSearch(false, true)
    @eventAggregator.trigger('sessionListChange')

  createSearchQuery: (query={}) ->
    attributes = _.extend({}, query, {
      uuid: @uuid
      reviewMode: true
    })
    new Monitoring.Models.SearchQuery(attributes, defaultCharts: [])

  showResults: =>
    @restoreResults() if @resultsElement
    @resultsElement = ''
    @$el.find('#results').removeClass('hidden')

  afterSearch: (dashboardResults) ->
    @$el.find('#dashboard-content').unblock()
    @$el.find('#results').show()
    return if @filtersRendered

    @trigger('afterFirstSearch', { name: dashboardResults.review_queue_name, sizeInformation: dashboardResults.size_information})
    @searchQuery.set('name', dashboardResults.review_queue_name)
    @renderFilters(dashboardResults)

  renderFilters: (dashboardResults) =>
    @filterView.destroy()
    @filterView = new Monitoring.Views.SocialContents.Filters.ReviewQueueFiltersView(
      socialContentCondition: dashboardResults.social_content_condition,
      topics: @topics,
      tagsByClientCode: dashboardResults.tags_by_client_code,
      availableSubtypes: dashboardResults.available_subtypes,
      allSubtypes: dashboardResults.all_subtypes
    )
    @$el.find('#filters').append(@filterView.render().el)
    @filtersRendered = true

  destroy: ->
    @filterView.destroy()
    @results.destroy()
    $(window).off('resize', @adjustHeight)
    @remove()
    return false

  adjustHeight: =>
    headerHeight = $('#main-header').outerHeight()
    availableHeight = $(window).height() - headerHeight
    @$el.find('.mini-scrollbar').css('height', availableHeight)

  _activateOnBeforeUnloadEvent: ->
    window.addEventListener('beforeunload', (e) =>
      $.post('/monitoring/dashboard/queue_release.json/', uuid: @uuid)
      return;
    )
